module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA3ElEQVRYR+1WQRKCMAxMHuBH1JveSf7gf4SXpfbuke8Qp4ww2BGnnRFzMNwYmu52ky6LYPygMT44AVdgVkBEWkS8AMBh48EMqnpj5jbhzARCCAIAtDH4tH1PRMecgP4IfIQhovHwSwWcgCuwqoCqdoh4fTOkARF3qnrKv32oqRtCVWVmDjHG/TAM/QSEiPemac7pPb/CazVLksW3wJxAYm3agq3MqbgFTuCvFLD9HZsHktJeiwg9bTkPLynpdMk1S/d6yQM1RWntgshoVLXAs6XXAn97vcdyV8BcgQcjYbMh7f+ZogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/icon-comments.png
// module id = 925
// module chunks = 0